"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileSystemMenuList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const hooks_1 = require("../../hooks");
const selectors_1 = require("../../store/selectors");
const SystemMenu_1 = require("../SystemMenu");
// eslint-disable-next-line max-lines-per-function
function MobileSystemMenuList(props) {
    const systems = (0, hooks_1.useSelector)(selectors_1.getSystemStates);
    const { scrollContainerRef, canScrollLeft, canScrollRight, startScrolling, stopScrolling, } = (0, ui_1.useScrollButtons)();
    const swipeStartX = (0, react_1.useRef)(0);
    const [isSwiping, setIsSwiping] = (0, react_1.useState)(false);
    const [selectedSystemId, setSelectedSystemId] = (0, react_1.useState)(null);
    const onClose = () => {
        setSelectedSystemId(null);
    };
    const touchStartX = (0, react_1.useRef)(0);
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };
    const handleTouchMove = (e) => {
        if (!scrollContainerRef.current)
            return;
        const deltaX = touchStartX.current - e.touches[0].clientX;
        scrollContainerRef.current.scrollLeft += deltaX;
        touchStartX.current = e.touches[0].clientX;
    };
    const onSwipeStart = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        const startX = e.type === 'touchstart'
            ? e.touches[0].clientX
            : e.clientX;
        swipeStartX.current = startX;
        setIsSwiping(true);
    }, [setIsSwiping]);
    const onSwipeMove = (0, react_1.useCallback)((e) => {
        if (!isSwiping)
            return;
        const currentX = e.type === 'touchmove'
            ? e.touches[0].clientX
            : e.clientX;
        const deltaX = currentX - swipeStartX.current;
        if (Math.abs(deltaX) > 60) {
            if (deltaX > 0 && canScrollLeft) {
                startScrolling('left');
            }
            else if (deltaX < 0 && canScrollRight) {
                startScrolling('right');
            }
        }
    }, [isSwiping, canScrollLeft, canScrollRight, startScrolling]);
    const onSwipeEnd = (0, react_1.useCallback)(() => {
        if (isSwiping) {
            setIsSwiping(false);
            stopScrolling();
        }
    }, [isSwiping, setIsSwiping, stopScrolling]);
    (0, react_1.useEffect)(() => {
        if (systems.length === 1) {
            setSelectedSystemId(systems[0].identifier);
        }
    }, [systems]);
    const onItemClick = (id) => {
        setSelectedSystemId(id);
    };
    const selectedSystem = systems.find(({ identifier }) => identifier === selectedSystemId);
    return ((0, jsx_runtime_1.jsxs)(Container, { "$canScrollLeft": canScrollLeft, "$canScrollRight": canScrollRight, "data-e2e": 'MobileSystemMenuList_Container', children: [(0, jsx_runtime_1.jsxs)(ScrollContainer, { "$isDisplayed": selectedSystemId == null, "data-e2e": 'MobileSystemMenuList_ScrollContainer', children: [canScrollLeft && ((0, jsx_runtime_1.jsx)(ButtonContainer, { direction: "left", "data-e2e": 'MobileSystemMenuList_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.DirectionButton, { direction: "left", onMouseDown: () => startScrolling('left'), onMouseUp: stopScrolling, onMouseLeave: stopScrolling, onTouchStart: () => startScrolling('left'), onTouchEnd: stopScrolling, "data-e2e": 'MobileSystemMenuList_DirectionButton' }) })), (0, jsx_runtime_1.jsx)(MenuItems, { ref: scrollContainerRef, canScrollLeft: canScrollLeft, canScrollRight: canScrollRight, onTouchEnd: onSwipeEnd, onMouseDown: onSwipeStart, onMouseMove: onSwipeMove, onMouseUp: onSwipeEnd, onMouseLeave: onSwipeEnd, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, "data-e2e": 'MobileSystemMenuList_MenuItems', children: systems.map(system => ((0, jsx_runtime_1.jsx)(SystemMenu_1.SystemMenu, { onClick: onItemClick, system: system, isMobile: true, resetButtonPressed: props.resetButtonPressed, setResetButtonPressed: props.setResetButtonPressed, "data-e2e": 'MobileSystemMenuList_SystemMenu' }, system.identifier))) }), canScrollRight && ((0, jsx_runtime_1.jsx)(ButtonContainer, { direction: "right", "data-e2e": 'MobileSystemMenuList_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.DirectionButton, { direction: "right", onMouseDown: () => startScrolling('right'), onMouseUp: stopScrolling, onMouseLeave: stopScrolling, onTouchStart: () => startScrolling('right'), onTouchEnd: stopScrolling, "data-e2e": 'MobileSystemMenuList_DirectionButton' }) }))] }), (0, jsx_runtime_1.jsx)(StyledCSSTransition, { in: selectedSystemId !== null, timeout: 300, mountOnEnter: true, unmountOnExit: true, classNames: "slide", "data-e2e": 'MobileSystemMenuList_StyledCSSTransition', children: !selectedSystem ? ((0, jsx_runtime_1.jsx)("div", { "data-e2e": 'MobileSystemMenuList_div' })) : ((0, jsx_runtime_1.jsxs)(ExpandedSystemMenu, { "$isActive": selectedSystem.isActive, "data-e2e": 'MobileSystemMenuList_ExpandedSystemMenu', children: [(0, jsx_runtime_1.jsx)(StyledCloseButton, { onClick: onClose, "data-e2e": 'MobileSystemMenuList_StyledCloseButton' }), (0, jsx_runtime_1.jsx)(SystemMenuContainer, { "data-e2e": 'MobileSystemMenuList_SystemMenuContainer', children: (0, jsx_runtime_1.jsx)(SystemMenu_1.SystemMenu, { isExpanded: true, isSelected: true, isMobile: true, system: selectedSystem, onClick: () => { }, resetButtonPressed: props.resetButtonPressed, setResetButtonPressed: props.setResetButtonPressed, "data-e2e": 'MobileSystemMenuList_SystemMenu' }) })] })) })] }));
}
exports.MobileSystemMenuList = MobileSystemMenuList;
const ScrollContainer = styled_components_1.default.div `
  display: ${({ $isDisplayed }) => ($isDisplayed ? 'flex' : 'none')};
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
`;
const StyledCloseButton = (0, styled_components_1.default)(ui_1.CloseButton) `
  position: absolute;

  width: 40px;
  height: 40px;

  right: 0;

  z-index: 99;

  & svg {
    height: 20px;
    width: 20px;
  }
`;
const StyledCSSTransition = (0, styled_components_1.default)(react_transition_group_1.CSSTransition) `
  &.slide-enter {
    transform: translateY(75%);
  }
  &.slide-enter-active {
    transform: translateY(-55%);
    transition: transform 300ms ease-out;
  }
  &.slide-exit {
    transform: translateY(-55%);
  }
  &.slide-exit-active {
    transform: translateY(75%);
    transition: transform 300ms ease-out;
  }
`;
const ExpandedSystemMenu = styled_components_1.default.div `
  position: fixed;
  left: 8px;
  width: calc(100vw - 16px);
  transform: translateY(-55%);
  box-sizing: border-box;
  border-radius: 8px;

  z-index: 99;

  background-color: ${({ theme }) => theme.grasshopper.background};
`;
const SystemMenuContainer = styled_components_1.default.div `
  margin-top: 16px;
`;
const Container = styled_components_1.default.div `
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.grasshopper.background};
  overflow: hidden;
  border-radius: ${({ $canScrollLeft, $canScrollRight }) => {
    if ($canScrollLeft && $canScrollRight)
        return '0px';
    if ($canScrollLeft)
        return '0px 8px 8px 0px';
    if ($canScrollRight)
        return '8px 0px 0px 8px';
    return '8px';
}};
  margin: ${({ $canScrollLeft, $canScrollRight }) => {
    if ($canScrollLeft && $canScrollRight)
        return '8px 0';
    if ($canScrollLeft)
        return '8px 8px 8px 0';
    if ($canScrollRight)
        return '8px 0 8px 8px';
    return '8px';
}};
`;
const MenuItems = styled_components_1.default.div `
  height: 100%;
  display: flex;
  box-sizing: border-box;
  position: relative;
  padding: 4px 8px;
  flex-direction: row;
  gap: 8px;
  overflow: hidden;
  background-color: none;

  ${({ canScrollLeft }) => canScrollLeft &&
    (0, styled_components_1.css) `
      padding-left: 16px;
      margin-left: 0;
    `}

  ${({ canScrollRight }) => canScrollRight &&
    (0, styled_components_1.css) `
      padding-right: 16px;
      margin-right: 0;
    `}
`;
const ButtonContainer = styled_components_1.default.div `
  padding: 24px 10px;
  z-index: 11;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${({ theme }) => theme.grasshopper.background};

  ${({ direction, theme }) => direction === 'left'
    ? `left: 0; box-shadow: 20px 0px 16px 0px ${theme.grasshopper.background}CC;`
    : `right: 0; box-shadow: -20px 0px 16px 0px ${theme.grasshopper.background}CC;`}
`;
